import { render, staticRenderFns } from "./voucherMessage.vue?vue&type=template&id=6c184908&scoped=true"
import script from "./voucherMessage?vue&type=script&lang=js&external"
export * from "./voucherMessage?vue&type=script&lang=js&external"
import style0 from "./voucherMessage.vue?vue&type=style&index=0&id=6c184908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c184908",
  null
  
)

export default component.exports